module.exports = __webpack_public_path__ + "media/images/brand/app_logo_full_original-95dae844e1faba6a821f95a222c85818.png";